import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10a9d58b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "报修内容", -1));
const _hoisted_3 = {
  class: "store"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报修门店", -1));
const _hoisted_5 = {
  class: "black"
};
const _hoisted_6 = {
  class: "location"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报修点位", -1));
const _hoisted_8 = {
  class: ""
};
const _hoisted_9 = {
  class: "location"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "对接人", -1));
const _hoisted_11 = {
  class: ""
};
const _hoisted_12 = {
  class: "location"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系方式", -1));
const _hoisted_14 = {
  class: ""
};
const _hoisted_15 = {
  class: "location miaoshu"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "需求描述", -1));
const _hoisted_17 = {
  class: ""
};
const _hoisted_18 = {
  class: "imgUp"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "照片墙", -1));
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 0,
  class: "btnBox"
};
const _hoisted_22 = {
  key: 1,
  class: "btnBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($setup.uploadTableData.storeInfo.storeName), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString($setup.uploadTableData.storeInfo.storeFloor + "-" + $setup.uploadTableData.storeInfo.locationDescription), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString($setup.uploadTableData.storeInfo.storeStaffName), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString($setup.uploadTableData.storeInfo.storeStaffMobile), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString($setup.uploadTableData.storeInfo.reporterDescription), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", null, [_createVNode(_component_el_upload, {
    "file-list": $setup.uploadTableData.storeInfo.badPhoto,
    "list-type": "picture-card",
    "on-preview": $setup.handlePictureCardPreview,
    ref: "uploadTable",
    action: $setup.uploadTableData.signatureData.host,
    data: $setup.uploadTableData.data,
    disabled: "",
    accept: "image/*"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["file-list", "on-preview", "action", "data"]), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.dialogVisible = $event),
    class: "imgPreview",
    style: {
      "width": "90vw"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      src: $setup.dialogImageUrl,
      alt: "Preview Image"
    }, null, 8, _hoisted_20)]),
    _: 1
  }, 8, ["modelValue"])])]), $setup.uploadTableData.storeInfo.repairResultId === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_button, {
    class: "defaultBtn",
    color: "#000"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.uploadTableData.storeInfo.repairResultNameZh), 1)]),
    _: 1
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_22, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    class: "defaultBtn",
    color: "#000",
    onClick: _cache[1] || (_cache[1] = $event => $setup.goRepairInfo())
  }, {
    default: _withCtx(() => [_createTextVNode("下一步")]),
    _: 1
  })), [[_directive_loading, $setup.fullscreenLoading, void 0, {
    fullscreen: true,
    lock: true
  }]])]))]);
}